import * as React from 'react'; 
import _ from 'lodash'; 
import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

interface Props {    
    categories: string[]; 
    columnTitle: string;     
    seriesColumn: number[];     
    seriesLine: number[];
    seriesType: string; 
    lineTitle: string; 
    title: string;     
}

const HorizontalBarTwoSeries: React.FC<Props> = ({
    categories, 
    columnTitle,
    seriesColumn,
    seriesLine,
    seriesType,
    lineTitle,
    title
}) => { 
    const options: ApexOptions = {
        title: {
            text: title,
            align: 'center',
            margin: 20,
            floating: true, 
            style: {
                fontSize: '20px'
            }
        },
        labels: categories,
        stroke: {
            width: [0, 4]
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [1]
        },
        chart: {   
            toolbar: { 
                show: true, 
                offsetY: 10,
                offsetX: -10, 
                tools: {
                    download: true,
                    selection: false,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true ,
                    customIcons: []
                }
            },                      
            zoom: {
                enabled: true,
            }
        },
        xaxis: {
            labels: {
                rotateAlways: true, 
                rotate: -45
            }
        }, 
        yaxis: { 
            labels: {
                formatter: function(value: number) {
                    const prefix = seriesType === 'money' ? '$' : ''; 
                    if(value >= 1000){
                        return prefix + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                        return prefix + value;
                    } 
                }
            } 
        }
    }; 

    const series: ApexOptions["series"] = [
        {
            name: columnTitle,
            type: 'column',
            data: seriesColumn || []
        }, 
        {
            name: lineTitle,
            type: 'line',
            data: seriesLine || []
        }
    ]

    return (
        <ReactApexChart 
            options={options} 
            series={series} 
            type="line" 
            height="100%" 
        />
    );
}
   
export default HorizontalBarTwoSeries; 